import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { HousingUnitCreatePage } from './housing-unit-create';
import { ComponentsModule } from '../../components/components.module';


@NgModule({
	declarations: [
		HousingUnitCreatePage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(HousingUnitCreatePage),
	],
})
export class HousingUnitCreatePageModule {}



// WEBPACK FOOTER //
// ./src/pages/housing-unit-create/housing-unit-create.module.ts